import script from "./AdminDashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminDashboardPage.vue?vue&type=style&index=0&id=3494a162&lang=css"
import "./AdminDashboardPage.vue?vue&type=style&index=1&id=3494a162&lang=css"

const __exports__ = script;

export default __exports__